<div class="pie-card">
  <div class="pie-header">
    <div>
      <span class="chart-eyebrow">Analytics</span>
      <h2 class="chart-title">Top 10 Clientes</h2>
      <p class="chart-subtitle">Clientes que mais compraram na empresa, com ticket e última compra</p>
    </div>
    <button class="btn btn-outline-secondary btn-sm" type="button" (click)="carregarDados()" [disabled]="isLoading">
      Atualizar
    </button>
  </div>

  <div *ngIf="isLoading" class="state-box">
    <div class="spinner-border text-primary" role="status"></div>
    <span>Carregando dados...</span>
  </div>

  <div *ngIf="hasError && !isLoading" class="state-box error">
    <span>Não foi possível carregar os dados.</span>
    <button class="btn btn-primary btn-sm" type="button" (click)="carregarDados()">Tentar novamente</button>
  </div>

  <div *ngIf="!isLoading && !hasError" class="table-shell">
    <div class="table-summary">
      <strong>Ranking dos {{ dados.length }} melhores clientes</strong>
      <span>Ordenado pelo volume de compras</span>
    </div>

    <div class="table-scroll">
      <table class="table table-hover align-middle mb-0">
        <thead class="table-light sticky-head">
          <tr>
            <th scope="col" class="text-center">#</th>
            <th scope="col">Cliente</th>
            <th scope="col">Telefone</th>
            <th scope="col" class="text-center">Orçamentos</th>
            <th scope="col" class="text-end">Maior Ticket</th>
            <th scope="col" class="text-end">Ticket Médio</th>
            <th scope="col" class="text-center">Última Compra</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let cliente of dados; let i = index">
            <td class="text-center">
              <span class="rank-badge" [class.rank-top3]="i < 3">{{ i + 1 }}º</span>
            </td>
            <td class="fw-semibold">{{ cliente.nomeRazaoSocial }}</td>
            <td>{{ cliente.telefone | mask: '(00) 00000-0000' }}</td>
            <td class="text-center">{{ cliente.orcamentos }}</td>
            <td class="text-end">{{ cliente.maiorTicket | currency:'BRL' }}</td>
            <td class="text-end fw-semibold">{{ cliente.ticketMedio | currency:'BRL' }}</td>
            <td class="text-center">{{ cliente.ultimaCompra | date:'dd/MM/yyyy' }}</td>
          </tr>
          <tr *ngIf="dados.length === 0">
            <td colspan="7" class="text-center text-muted py-4">Nenhum cliente retornado pelo endpoint.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
